module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('list', {
    attrs: {
      "listTitle": "Checkout de anúncios",
      "listLogo": _vm.moduleDefinition.logo,
      "filterTitle": "Filtros",
      "sortFields": _vm.sortFields,
      "sortDefault": {
        field: _vm.sortFields[0],
        order: 'asc'
      },
      "loading": _vm.loading,
      "total": _vm.announcements.total
    },
    on: {
      "change": _vm.onChange
    }
  }, [_c('template', {
    slot: "filters"
  }, [_c('form-group', {
    attrs: {
      "label": "Conta"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedAccount),
      expression: "selectedAccount"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedAccount = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v(_vm._s(_vm.$t('choose.label')))]), _vm._v(" "), _vm._l((_vm.mercadoLivreAccounts), function(account) {
    return _c('option', {
      domProps: {
        "value": account.identifier
      }
    }, [_vm._v(_vm._s(((account.name) + " (" + (account.nickname) + ")")))])
  })], 2)])], 1), _vm._v(" "), (_vm.announcements.items && _vm.selectedAccount) ? _c('div', {
    staticClass: "l-col-12@md"
  }, _vm._l((_vm.announcements.items.identifiers), function(announcement) {
    return _c('announcement-match-card', {
      key: announcement,
      attrs: {
        "announcement": announcement,
        "account": _vm.selectedAccount
      }
    })
  }), 1) : _c('div', {
    staticClass: "l-col-12@md u-textCenter"
  }, [_c('panel', [_vm._v("Nenhum anúncio encontrado.")])], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-683bea52","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/AnnouncementMatch/List.vue
// module id = 3249
// module chunks = 0